import React from 'react';
import ReactPlayer from 'react-player';
// import { createProxyMiddleware } from 'http-proxy-middleware';
// const proxy = createProxyMiddleware({
//     target: 'https://drive.google.com/',
//     changeOrigin: true,
//   });

const VideoPlayer = () => {
//   const videoUrl = 'https://drive.google.com/file/d/1h8YnHks3uQo6HB5nkWX1BRbbEw9-GqUH/view?usp=sharing'; // replace with your shareable link
    const videoFile = 'Givehope.mp4'; // replace with your video file name/path in public folder

  return (
    <div className=' justify-center flex items-center mt-20'>
        <ReactPlayer
        url={videoFile}
        width='60%'
        height='auto'
        playing
        controls
        loop
        />
    </div>
  );
};

export default VideoPlayer;